import React, { useEffect, useRef, useState } from "react";
import { logo, logoColor, welcomeVideo } from "../../constant/imagePath";
import { Button } from "../../stories/Button/Button";
import classes from "./WelcomePage.module.css";
import beforeLoginHeaderCSS from "../../stories/BeforeLoginHeader/beforeloginheader.module.css";
import { BeforeLoginHeader } from "../../stories/BeforeLoginHeader/BeforeLoginHeader";
import { useHistory } from "react-router-dom";
import $ from "jquery";
import { isMobileViewHook } from "../../CustomHooks/isMobileViewHook";
import WelcomePageMobile from "./WelcomePageMobile";
import Fonts from "../../stories/assets/Fonts";

import LinkBtnClasses from "../../stories/LinkButtonWithIcon/LinkButtonWithIcon.module.css";
import MonthSmallCalander from "../../components/MonthSmallCalander";

const WelcomePageDesktop = () => {
  const history = useHistory();
  const videoRef = useRef(null);

  const [section1Hover, setSection1Hover] = useState(false);
  const [section2Hover, setSection2Hover] = useState(false);

  const handleHoverSetter = (setterTrue, setterFalse, isBlackLogo) => {
    setterTrue(true);
    setterFalse(false);
  };
  const handleHoverSetterFalse = () => {
    setSection1Hover(false);
    setSection2Hover(false);
  };

  return (
    <>
      <style jsx>{`
        .${classes.titleText} {
          font-size: ${Fonts.h1.fontSize};
          line-height: ${Fonts.h1.lineHeight};
          font-family: ${`${Fonts.h1.fontFamily}`};
        }
        .${classes.detailText} {
          font-size: ${Fonts.p1.fontSize};
          line-height: ${Fonts.p1.lineHeight};
          font-family: ${`${Fonts.p1.fontFamily}`};
        }
        .${classes.orText} {
          font-size: ${Fonts.h6.fontSize};
          line-height: ${Fonts.h6.lineHeight};
          font-family: ${`${Fonts.h6.fontFamily}`};
        }
        .${beforeLoginHeaderCSS?.linkContainer} span {
          color: ${section2Hover ? "#717171 !important" : "white !important"};
        }
        .${LinkBtnClasses?.blueColor} {
          color: ${section2Hover ? "#4D55E5 !important" : "white !important"};
        }
        .${LinkBtnClasses?.blueIcon} path {
          stroke: ${section2Hover ? "#4D55E5 !important" : "white !important"};
        }
      `}</style>

      <div className={`text-white ${[classes.welcomeSection].join(" ")}`}>
        <video
          ref={videoRef}
          loop
          autoPlay
          muted
          className={`${[classes.bannerVideo].join(" ")}`}
        >
          <source src={welcomeVideo} type="video/mp4" />
        </video>

        <div className="p-0 container-fluid">
          <div
            className={`row ${[
              (section1Hover || section2Hover) && classes.isHover,
            ].join(" ")}`}
          >
            <BeforeLoginHeader
              onClick={() => {
                history.push({
                  pathname: "login",
                });
              }}
              icon={section1Hover ? logoColor : logo}
              text1={"Already have an account?"}
              text2={"Log in"}
              customStyle={{
                zIndex: 99,
              }}
            />
            <div
              className={` ${[
                classes.orContainer,
                (section1Hover || section2Hover) && classes.isHover,
              ].join(" ")}`}
            >
              <span>
                <div
                  className={` ${[
                    classes.orInnerContainer1,
                    classes.orText,
                  ].join(" ")}`}
                  onMouseOver={() => {
                    handleHoverSetter(
                      setSection1Hover,
                      setSection2Hover,
                      false
                    );
                  }}
                  onMouseOut={() => {
                    handleHoverSetterFalse();
                  }}
                >
                  O
                </div>
                <div
                  className={` ${[
                    classes.orInnerContainer2,
                    classes.orText,
                  ].join(" ")}`}
                  onMouseOver={() => {
                    handleHoverSetter(setSection2Hover, setSection1Hover, true);
                  }}
                  onMouseOut={() => {
                    handleHoverSetterFalse();
                  }}
                >
                  R
                </div>
              </span>
            </div>
            <div
              className={`p-5 col-md-6 ${[classes.innerContainer].join(" ")}`}
              style={Object.assign(
                {},
                section1Hover && { backgroundColor: "white" }
              )}
              onMouseOver={() => {
                handleHoverSetter(setSection1Hover, setSection2Hover, false);
              }}
              onMouseOut={() => {
                handleHoverSetterFalse();
              }}
            >
              <span
                className={`mb-3 ${[classes.titleText].join(" ")}`}
                style={Object.assign({}, section1Hover && { color: "black" })}
              >
                Become a Student
              </span>
              <span
                className={`mb-3 ${[classes.detailText].join(" ")}`}
                style={Object.assign({}, section1Hover && { color: "black" })}
              >
                I want to find a coach and book a training through this service.
              </span>
              <Button
                primary={section1Hover}
                disabled={false}
                size={"Medium"}
                label={"Continue"}
                onClick={() => {
                  history.push({
                    pathname: "socialSignupStudent",
                  });
                }}
                customStyle={{
                  width: "auto",
                  padding: "0% 5%",
                  border: "1px solid white",
                  color: "white",
                }}
              />
            </div>
            <div
              className={`p-5 col-md-6 ${[classes.innerContainer].join(" ")}`}
              style={Object.assign(
                {},
                section2Hover && { backgroundColor: "white" }
              )}
              onMouseOver={() => {
                handleHoverSetter(setSection2Hover, setSection1Hover, true);
              }}
              onMouseOut={() => {
                handleHoverSetterFalse();
              }}
            >
              <span
                className={`mb-3 ${[classes.titleText].join(" ")}`}
                style={Object.assign({}, section2Hover && { color: "black" })}
              >
                Become a Coach
              </span>
              <span
                className={`mb-3 ${[classes.detailText].join(" ")}`}
                style={Object.assign({}, section2Hover && { color: "black" })}
              >
                I want to do sports training and also get paid easily.
              </span>
              <Button
                primary={section2Hover}
                disabled={false}
                size={"Medium"}
                label={"Continue"}
                onClick={() => {
                  history.push({
                    pathname: "socialSignupCoach",
                  });
                }}
                customStyle={{
                  width: "auto",
                  padding: "0% 5%",
                  border: "1px solid white",
                  color: "white",
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

function WelcomePage() {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    isMobileViewHook(setIsMobile);
  }, [window.innerWidth]);

  return <div>{isMobile ? <WelcomePageMobile /> : <WelcomePageDesktop />}</div>;
}

export default WelcomePage;
